export const GET_AGENDA_REQUEST = 'GET_AGENDA_REQUEST';
export const GET_AGENDA_SUCCESS = 'GET_AGENDA_SUCCESS';
export const GET_AGENDA_FAILURE = 'GET_AGENDA_FAILURE';
export const SET_EVENTS_AGENDA = 'SET_EVENTS_AGENDA';
export const RESET_EVENTOS = 'RESET_EVENTOS';
export const SET_COMPLETADO_EVENTO = 'SET_COMPLETADO_EVENTO';
export const DELETE_EVENT = 'DELETE_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';
